module.exports = __webpack_public_path__ + "img/game_field.7c17317d.svg";